{
  "en": {
    "datatable": {
      "actions": {
        "bulk_action": "Bulk action",
        "bulk_edit": "Bulk edit",
        "clear": "Clear",
        "clear_filters": "Clear filters",
        "collapse_all": "Collapse all",
        "deselect_all": "Deselect all",
        "expand_all": "Expand all",
        "select_all": "Select all"
      },
      "import": {
        "error_row": "Row {row}",
        "errors_description": "The import was cancelled because {count} row(s) contained errors. No records were imported.",
        "errors_title": "Import failed",
        "success": "File imported successfully",
        "title": "Import"
      },
      "labels": {
        "freeze_columns": "Freeze columns",
        "freeze_rows": "Freeze rows",
        "gridlines": "Grid lines",
        "group_by": "Group by",
        "size": "Size",
        "sticky_headers": "Sticky headers",
        "striped_rows": "Striped rows",
        "toggle_columns": "Toggle columns"
      }
    }
  }
}
